import { serviceData } from '../../l-data/services';
import Translatable from '../translatable_text/Translatable';
import ServiceCard from './ServiceCard';

function DigitalProducts() {
  return (
    <section className="services-crev section-paddingx" data-scroll-index="1">
      <div className="max-w-7xl mx-auto mt-80 px-4 d-rotate wow">
        <div className="sec-head mb-80">
          <h2 className="sub-title main-color mb-25">
            <Translatable>
              Explore Our Digital Assets
            </Translatable>
          </h2>
          <div className="bord pt-25 bord-thin-top flex items-center justify-between ">
              <h2 className="ltr:hidden fw-600 text-4xl d-rotate wow">
                <span className="rotate-text">
                  <Translatable>
                    Our Products
                  </Translatable>
                </span>
              </h2>
              <h2 className="rtl:hidden fw-600 text-4xl d-rotate wow">
                <span className="rotate-text">
                  Digital <span className="fw-200"> Assets</span></span>
              </h2>
            <div className='flex items-center justify-center'>
              <a href="/services" aria-label='go to services page' className="go-more flex items-center gap-3">
                <span className="text underline">
                  <Translatable>
                    View all Services
                  </Translatable>
                </span>
                {/* <span className="icon ti-arrow-top-right"></span> */}
                <img 
                  src="/light/assets/imgs/arrow-right.webp"
                  alt="icon"
                  className="icon-img-20 ml-5 -mr-1"
                  width="40px"
                  height="40px"
                />
              </a>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 my-40">
          {serviceData.map((item, i) => (
            <ServiceCard key={i} service={item}/>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DigitalProducts;
